var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"roma-modal-top",style:({ 'height': _vm.height })},[_c('img',{attrs:{"src":require('../../assets/wall-colors.png')}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }